import * as React from "react";
export class HeadingName extends React.PureComponent {
    render() {
        return (React.createElement("div", { key: `k_${name}`, className: "rj-ev-list__heading-name", "data-uat": "div-ev-list-heading-name" }, this.props.name));
    }
}
//# sourceMappingURL=HeadingName.js.map